import axios from 'axios'
import store from '@/store'

const report2Client = axios.create({})

report2Client.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.getters['auth/getToken']}`
    config.headers.lang = store.getters['getLang']
    config.url = `${process.env.VUE_APP_PROTOCOL}://${store.getters['auth/getTenantHost']}/report-2-0/api/v1${config.url}`
    return config;
})

export default report2Client
